import { setCookies, getCookies, removeCookies } from '@/utils/cookie'
import { clone } from '@/utils'
// const CONFIG = 'tagsView'
// const initTagsView = getCookies(CONFIG)

const warpRoute = (routes) => {
	return routes.map(a => {
		return {
			fullPath: a.fullPath,
			meta: a.meta,
			name: a.name,
			path: a.path,
			title: a.title
		}
	})
}

const state = {
  visitedViews: [],
  cachedViews: [],
		erpVisitedViews: []
}

const mutations = {
  ADD_VISITED_VIEW: (state, view) => {
		  const { meta: { erp } } = view || { meta: { erp: false } }
		  if (erp && !state.erpVisitedViews.some(v => v.path === view.path)) {
				  state.erpVisitedViews.push(
						  Object.assign({}, view, {
								  title: view.meta.title || 'no-name'
						  })
				  )
		  }
    if (state.visitedViews.some(v => v.path === view.path)) return
    state.visitedViews.push(
      Object.assign({}, view, {
        title: view.meta.title || 'no-name'
      })
    )
  },
  ADD_CACHED_VIEW: (state, view) => {
    if (state.cachedViews.includes(view.name)) return
    if (!view.meta.noCache) {
      state.cachedViews.push(view.name)
    }
    // const value = state && state.visitedViews
				// setCookies(CONFIG, value.map(a => clone(a, ['matched'])))
  },

  DEL_VISITED_VIEW: (state, view) => {
		  for (const [i, v] of state.erpVisitedViews.entries()) {
				  if (v.path === view.path) {
						  state.erpVisitedViews.splice(i, 1)
						  break
				  }
		  }
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path === view.path) {
        state.visitedViews.splice(i, 1)
        break
      }
    }
  },
  DEL_CACHED_VIEW: (state, view) => {
    const index = state.cachedViews.indexOf(view.name)
    index > -1 && state.cachedViews.splice(index, 1)

    // 重新缓存tag集合
    // const value = state && state.visitedViews
    // setCookies(CONFIG, value.map(a => clone(a, ['matched'])))
  },

  DEL_OTHERS_VISITED_VIEWS: (state, view) => {
		  state.erpVisitedViews = state.erpVisitedViews.filter(v => {
				  return v.meta.affix || v.path === view.path
		  })
    state.visitedViews = state.visitedViews.filter(v => {
      return v.meta.affix || v.path === view.path
    })
  },
  DEL_OTHERS_CACHED_VIEWS: (state, view) => {
    const index = state.cachedViews.indexOf(view.name)
    if (index > -1) {
      state.cachedViews = state.cachedViews.slice(index, index + 1)
    } else {
      // if index = -1, there is no cached tags
      state.cachedViews = []
    }
	  // const value = state && state.visitedViews
	  // setCookies(CONFIG, value.map(a => clone(a, ['matched'])))
  },

  DEL_ALL_VISITED_VIEWS: state => {
    // keep affix tags
		  state.erpVisitedViews = state.visitedViews.filter(tag => tag.meta.affix && tag.meta.erp)
    const affixTags = state.visitedViews.filter(tag => tag.meta.affix)
    state.visitedViews = affixTags
  },
  DEL_ALL_CACHED_VIEWS: state => {
    state.cachedViews = []
  },

  UPDATE_VISITED_VIEW: (state, view) => {
    for (let v of state.visitedViews) {
      if (v.path === view.path) {
        v = Object.assign(v, view)
        break
      }
    }
  }
}

const actions = {
  addView({ dispatch }, view) {
    dispatch('addVisitedView', view)
    dispatch('addCachedView', view)
  },
  addVisitedView({ commit }, view) {
    commit('ADD_VISITED_VIEW', view)
  },
  addCachedView({ commit }, view) {
    commit('ADD_CACHED_VIEW', view)
  },

  delEditView({dispatch, state}, tagName) {
    const view = state.visitedViews.find(item => item.name === tagName)
    return new Promise(resolve => {
      dispatch('delVisitedView', view)
      dispatch('delCachedView', view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },

  delView({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delVisitedView', view)
      dispatch('delCachedView', view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delVisitedView({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_VISITED_VIEW', view)
      resolve([...state.visitedViews])
    })
  },
  delCachedView({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_CACHED_VIEW', view)
      resolve([...state.cachedViews])
    })
  },

  delOthersViews({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delOthersVisitedViews', view)
      dispatch('delOthersCachedViews', view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delOthersVisitedViews({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_OTHERS_VISITED_VIEWS', view)
      resolve([...state.visitedViews])
    })
  },
  delOthersCachedViews({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_OTHERS_CACHED_VIEWS', view)
      resolve([...state.cachedViews])
    })
  },

  delAllViews({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delAllVisitedViews', view)
      dispatch('delAllCachedViews', view)
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      })
    })
  },
  delAllVisitedViews({ commit, state }) {
    return new Promise(resolve => {
      commit('DEL_ALL_VISITED_VIEWS')
      resolve([...state.visitedViews])
    })
  },
  delAllCachedViews({ commit, state }) {
    return new Promise(resolve => {
      commit('DEL_ALL_CACHED_VIEWS')
      resolve([...state.cachedViews])
    })
  },

  updateVisitedView({ commit }, view) {
    commit('UPDATE_VISITED_VIEW', view)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
